module.exports = __webpack_public_path__ + "static/media/how_it_works.22ef9c99.jpg";